// extracted by mini-css-extract-plugin
export default {"stats":"_3ywbI","hasIcons":"_1eYSY"};